import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Facebook,
  Twitter,
  Linkedin,
  Mail,
  Send
} from 'lucide-react';

const EventDetail = () => {
  const [eventData, setEventData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [conferenceId, setConferenceId] = useState(null);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        setLoading(true);
        
        // Get last value from URL - http://localhost:3000/conference/details/84
        const pathname = window.location.pathname;
        const pathParts = pathname.split('/').filter(Boolean);
        const id = pathParts[pathParts.length - 1]; // Gets "84"
        
        console.log('Current URL:', pathname);
        console.log('Extracted Conference ID:', id);
        
        setConferenceId(id);

        if (!id || isNaN(id)) {
          throw new Error('Invalid conference ID');
        }

        // Dynamic API URL with extracted ID
        const apiUrl = `https://eventscons.com/eventbackendnew/api/con/id/${id}`;
        console.log('Fetching:', apiUrl);
        
        const response = await axios.get(apiUrl);
        setEventData(response.data);
      } catch (error) {
        console.error('Error fetching event data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, []);

  if (loading) return <div className="text-center p-5">Loading...</div>;
  if (!eventData || !eventData.conference) return <div className="text-center p-5">No data found. ID: {conferenceId}</div>;

  const { conference, scientific_topics } = eventData;

  const fullImageUrl = conference?.image
    ? `https://eventscons.com/eventbackendnew/storage/app/public/${conference.image}`
    : '';

  return (
    <div className="container" style={{margin:'0px',marginTop:'0px',padding:'0px'}}>
      {/* Debug info */}
      {/* <div style={{padding: '10px 40px', background: '#f0f0f0', fontSize: '12px', color: '#666'}}>
        Conference ID: {conferenceId} | API: https://eventscons.com/eventbackendnew/api/con/id/{conferenceId}
      </div> */}
      
      <div className="mb-4">
        <img
          src={fullImageUrl}
          alt={conference.title}
          style={{ width: '100%', borderRadius: '20px 20px 0px 0px', objectFit: 'cover', minHeight: '400px' }}
          onError={(e) => {
            console.log('Image failed:', fullImageUrl);
            e.currentTarget.style.display = 'none';
          }}
        />
      </div>

      <div style={{paddingLeft:'40px',paddingRight:'40px'}}>
        <div className="event-description mb-5" style={{ color: '#333', lineHeight: '1.8', fontSize: '18px' }}>
          <h2 style={{ fontWeight: '700', marginBottom: '20px',textAlign:'left' }}>{conference.title}</h2>
          <p>{conference.description}</p>
        </div>

        <div className="d-flex flex-wrap gap-2 mb-5">
          {scientific_topics && scientific_topics.slice(0, 4).map((topic) => (
            <span
              key={topic.id}
              style={{
                backgroundColor: '#f1f1f1',
                padding: '12px 25px',
                fontSize: '13px',
                fontWeight: '600',
                color: '#000',
                borderRadius: '2px',
                letterSpacing: '1px'
              }}
            >
              {topic.title}
            </span>
          ))}
        </div>

        <hr style={{ borderTop: '1px solid #eee', marginBottom: '30px' }} />

        <div className="mt-4">
          <h5 style={{ fontWeight: '700', fontSize: '16px', marginBottom: '20px', letterSpacing: '1px' }}>
            SHARE THIS EVENT
          </h5>
          <div className="d-flex gap-3 flex-wrap">
            {[
              { icon: <Facebook size={18} />, name: 'facebook' },
              { icon: <Twitter size={18} />, name: 'x' },
              { icon: <Linkedin size={18} />, name: 'linkedin' },
              { icon: <Send size={18} />, name: 'telegram' },
              { icon: <Mail size={18} />, name: 'email' },
            ].map((item, index) => (
              <a
                href="#"
                key={index}
                style={{
                  width: '45px',
                  height: '45px',
                  backgroundColor: '#a3a8b5',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  textDecoration: 'none',
                  transition: '0.3s all ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#262626'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#a3a8b5'}
              >
                {item.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventDetail;